import {CBadge} from "@coreui/react";
import React from "react";
import BootstrapModal from "./BootstrapModal";
import {PRIORITY_BADGE} from "../../config/constants";

const TaskViewModal = ({ visible, task, onClose, onEdit }) => {
    if (!visible || !task) return null

    return (
        <BootstrapModal
            show={visible}
            title="Detalle de la tarea"
            onClose={onClose}
            size="lg"
            footer={
                <>
                    <button className="btn btn-secondary" onClick={onClose}>
                        Cerrar
                    </button>
                    <button className="btn btn-primary" onClick={() => onEdit(task)}>
                        Editar
                    </button>
                </>
            }
        >
            <div className="d-grid gap-3">
                <div>
                    <div className="d-flex align-items-start justify-content-between">
                        <h5 className="mb-0">{task.title}</h5>
                    </div>
                    {task.description && (
                        <p className="text-muted mt-2" style={{ whiteSpace: 'pre-wrap' }}>
                            {task.description}
                        </p>
                    )}
                </div>

                <div className="d-flex flex-wrap gap-2">
                    <CBadge color={PRIORITY_BADGE[task.priority]}>Prioridad {task.priority}</CBadge>
                    {task.assignee && <CBadge color="secondary">@{task.assignee}</CBadge>}
                    {task.dueDate && <CBadge color="secondary">Vence: {new Date(task.dueDate).toLocaleDateString()}</CBadge>}
                </div>

                <div className="border-top pt-3">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="fw-semibold">Comentarios</div>
                        <CBadge color="primary">{task.comments?.length || 0}</CBadge>
                    </div>

                    {(task.comments?.length || 0) === 0 ? (
                        <div className="text-muted small">Sin comentarios.</div>
                    ) : (
                        <div className="list-group">
                            {task.comments.map((c) => (
                                <div key={c.id} className="list-group-item d-flex flex-column gap-1">
                                    <div className="small text-muted">
                                        <strong>{c.author || 'anon'}</strong> · {new Date(c.createdAt).toLocaleString()}
                                    </div>
                                    <div style={{ whiteSpace: 'pre-wrap' }}>{c.text}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </BootstrapModal>
    )
}

export default TaskViewModal;